import React from "react";
import cn from "classnames";

const Separator = ({ className, color }) => {
    return (
        <div className={cn(
            "separator",
            className,
        )} style={{
            borderBottomColor: color ?? 'currentColor'
        }} />
    );
}

export default Separator;
